import React from 'react';

const SectionPlace = ({ event, setEvent, setEventDateError, placeError }) => {

  const onEventDateError = React.useCallback(() => {
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
    } else {
      setEventDateError('');
    }
  }, [event]);

  return (
    <section id="place">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          場所
          <span className="text-fz-14px text-fw-bold text-gray mb-2 mt-1 ml-2 d-inline-block">
            必須
          </span>
        </p>
      </div>

      <div
        className={`shadow-sm mb-0 ${
          !!placeError ? 'bg-light-pink' : 'bg-white'
        }`}
      >
        <div className="container col-md-8 col-lg-6 p-3_5">
          {placeError && (
            <p className="text-danger text-fz-small mb-0">{placeError}</p>
          )}
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">開催場所</p>
            <input
              id="place"
              defaultValue={event.place}
              onChange={(e) =>
                setEvent((prev) => ({ ...prev, place: e.target.value }))
              }
              onClick={() => onEventDateError()}
              className="col-8 p-0 textarea--eventreport text-right"
              placeholder="新宿駅西口"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionPlace;
